import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import AddBorder from '../../components/AddBorder';

const BorderPage: React.FC = () => (
  <ToolLayout
    title="Add Border to Image Online Free | AllTools"
    description="Add borders, frames, and shadows to images. Solid, gradient, and pattern styles. Free online tool."
    canonicalPath="/add-border"
  >
    <AddBorder />
  </ToolLayout>
);

export default BorderPage;
